import { Address } from '@/types/types'

export interface Company {
  _id: string
  name: string
  legalName: string
  description: string
  type: string[]
  category: string[]
  url: string
  email: string
  emailPublic: boolean
  phone: string
  facebook: string
  instagram: string
  whatsapp: string
  address: Address
  venue: string[]
  whitelabel: string
  active: boolean
}

export interface Venue {
  _id: string
  name: string
  url: string
  email: string
  emailPublic: boolean
  phone: string
  facebook: string
  instagram: string
  whatsapp: string
  address: Address
  enable: boolean
  company: string | Company
  externalId: string
}

// checks if a company has all required properties, defined in server modell
export function isValidCompany(company: any): company is Company {
  return (
    company.name !== undefined &&
    company.type !== undefined &&
    company.category !== undefined &&
    company.email !== undefined &&
    company.address !== undefined
  )
}
